import React from "react";
import ReactDOM from "react-dom";
import "./footer.css";

const Footer = () => (
  <footer className="footer">
    <div className="upper-footer">
      <div className="container">
        <li>
          <i className="icon icon-phone" aria-hidden="true"></i>
          <h3>Contact HSBC</h3>
          <a href="/help/contact/">
            <p>
              Enquire online, call or send a message&nbsp;
              <i className="icon icon-chevron-right-small"></i>
            </p>
          </a>
        </li>
        <li>
          <i className="icon icon-location" aria-hidden="true"></i>
          <h3>Find a branch</h3>
          <a href="/branch-finder/">
            <p>
              Find your nearest HSBC branch location&nbsp;
              <i className="icon icon-chevron-right-small"></i>
            </p>
          </a>
        </li>
        <li>
          <i className="icon icon-circle-info" aria-hidden="true"></i>
          <h3>Frequently Asked Questions</h3>
          <a href="/faqs/">
            <p>
              See FAQs on our products&nbsp;
              <i className="icon icon-chevron-right-small"></i>
            </p>
          </a>
        </li>
        <li>
          <i className="icon icon-global" aria-hidden="true"></i>
          <h3>About HSBC</h3>
          <a href="https://www.about.hsbc.com.au/">
            <p>
              Careers, media, investor and corporate information&nbsp;
              <i className="icon icon-chevron-right-small"></i>
            </p>
          </a>
        </li>
        <div className="clear"></div>
      </div>
    </div>
    <div className="lower-footer">
      <div className="container">
        <nav className="left-section">
          <ul>
            <li>
              <a href="/site-terms/" rel="nofollow">Site Terms</a>
            </li>
            <li>
              <a href="/hyperlink-policy/" rel="nofollow">Hyperlink Policy</a>
            </li>
            <li>
              <a href="/help/cookie-policy/" rel="nofollow">Cookie policy</a>
            </li>
            <li>
              <a href="/legal/" rel="nofollow">Legal &amp; Privacy</a>
            </li>
            <li>
              <a href="/help/important-notices/" rel="nofollow">Important Notices</a>
            </li>
          </ul>
        </nav>
        <div className="right-section">
          <p><a href="https://www.hsbc.com/" target="_blank" rel="noopener noreferrer">HSBC Group </a>
           | © HSBC Bank Australia Limited 2023 ABN 48 006 434 162 AFSL/Australian Credit Licence 232595  All rights reserved.<br></br>This website is designed for use in Australia. <a href="https://www.hsbc.com.au/legal/cross-border-banking/" target="_blank" rel="noopener noreferrer">Cross-border notice</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

ReactDOM.render(<Footer />, document.getElementById("footer-main-container"));
